setTimeout(function () {
  var fh = $("[data-product-form]").outerHeight();
  $(".innerdiv").css("height", fh);
}, 6000);
$(window).scroll(function () {
  if ($(this).scrollTop() > 150) {
    if($(".mobile_sticky").hasClass('Open_Crown_Product')){
      $(".mobile_sticky").removeClass("newClass");
    } else{
      $(".mobile_sticky").addClass("newClass");
    }
  } else {
    $(".mobile_sticky").removeClass("newClass");
  }

  const TabLabel = document.querySelector(".fast-simon-upsell-1704384824013");
  if (TabLabel) {
    var DescriptionTOP = $(".fast-simon-upsell-1704384824013").offset().top;
    if ($(this).scrollTop() > DescriptionTOP) {
      if($(".mobile_sticky").hasClass('Open_Crown_Product')){
        $("[data-product-form]").removeClass("newFormClass");
      } else{
        $("[data-product-form]").addClass("newFormClass");
      }
    } else {
      $("[data-product-form]").removeClass("newFormClass");
    }
  }
});
const rating_button = document.querySelector(".product__rating_main");
if (rating_button) {
  rating_button.addEventListener("click", () => {
    document
      .getElementById("tab-label-down")
      .scrollIntoView({ behavior: "smooth", block: "center" });
  });
}

  const mediaQuery = window.matchMedia("(max-width: 719px)");
  if (mediaQuery.matches) {
    const mobile_rating_buttons = document.querySelectorAll(
      ".mobile-description-tab .tab-label"
    );
    mobile_rating_buttons.forEach((tablabel) => {
      tablabel.addEventListener("click", (event) => {
        event.preventDefault();
        tablabel.classList.toggle("tablabel-open");
      });
    });

    document.addEventListener("DOMContentLoaded", function () {
      var tab2Elements = document.getElementsByClassName("tab-radio");

      for (var i = 0; i < tab2Elements.length; i++) {
        var currentElement = tab2Elements[i];

        if (currentElement.checked) {
          var nextElement = currentElement.nextElementSibling;

          if (nextElement) {
            nextElement.classList.add("tablabel-open");
          }
        }
      }
    });
  }


const dataQuantityPlus = document.querySelectorAll('.cartitems [data-quantity-plus]');
const dataQuantityMinus = document.querySelectorAll('.cartitems [data-quantity-minus]');

if(dataQuantityPlus){
  dataQuantityPlus.forEach(function(QuantityPlus) {
    QuantityPlus.addEventListener('click', function() {
      const QuantityValue = QuantityPlus.dataset.qvalue;
      const QuantityVariantID = QuantityPlus.dataset.cartitemid;
      const IntQuantityValue = parseInt(QuantityValue);
      console.log(QuantityVariantID);
      console.log("Plus Click");
      
      let updates = {
        'id': QuantityVariantID,
        'quantity': IntQuantityValue+1
      };

      console.log(updates)
      
      fetch(window.Shopify.routes.root + 'cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(updates)
      })
      .then(response => {
        return response.json();
      })
      .catch((error) => {
        console.error('Error:', error);
      });

    });
  });
}  

if(dataQuantityMinus){
  dataQuantityMinus.forEach(function(QuantityMinus) {
    QuantityMinus.addEventListener('click', function() {
      const QuantityValue = QuantityMinus.dataset.qvalue;
      const QuantityVariantID = QuantityMinus.dataset.cartitemid;
      const IntQuantityValue = parseInt(QuantityValue);
      console.log(QuantityVariantID);
      console.log("Minus Click");
      
      let updates = {
        'id': QuantityVariantID,
        'quantity': IntQuantityValue-1
      };
      
      fetch(window.Shopify.routes.root + 'cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(updates)
      })
      .then(response => {
        return response.json();
      })
      .catch((error) => {
        console.error('Error:', error);
      });

      
    });
  });
}

(function ($) {
  
$('.gallery-navigation--scroller').slick({
  dots: false,
  arrows:true,
  infinite: false,
  speed: 300,
  variableWidth: true,
  slidesToShow: 1,
  slidesToScroll: 5,
  swipe: true
});






const button = document.querySelector('.scrollToTopBtn');

const displayButton = () => {
  window.addEventListener('scroll', () => {
  
    if (window.scrollY > 400) {
      button.style.display = "block";
    } else {
      button.style.display = "none";
    }
  });
};

const scrollToTop = () => {
  button.addEventListener("click", () => {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    }); 
    console.log(event);
  });
};

displayButton();
scrollToTop();





  
})(jQuery);